module.exports = __webpack_public_path__ + "img/worldpay.84e0f19b.png";